import { useQuery } from 'react-query';
import getKycStatus, { KycStatusEnum } from 'API/handlers/kyc-status';

const useKycStatus = (enabled: boolean) => {
  const { data, isLoading, isFetched } = useQuery({
    queryKey: 'kycStatus',
    queryFn: getKycStatus,
    enabled: enabled,
    select: (response) => ({
      isCompleted: response.status === KycStatusEnum.completed,
      isPending: response.status === KycStatusEnum.pending,
      url: response.url,
    }),
  });

  return { data, isLoading, isFetched };
};

export default useKycStatus;
